import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  fallbackExplanation: {
    id: 'RewardBoxDialog.fallback.explanation',
    defaultMessage:
      'We were not able to display the 3d reward animation in your browser.',
  },
  clickToOpenIt: {
    id: 'RewardBoxDialog.text',
    defaultMessage: 'Click the box to open it',
  },
  hereWhatYouWon: {
    id: 'RewardBoxDialog.fallback.title',
    defaultMessage: 'Here is what you won:',
  },
});
